'use strict';

export default {
  availableFilters: {
    series: [],
    characters: [],
    creators: []
  },
  enabledFilters: []
}



// WEBPACK FOOTER //
// ./src/stores/modules/products-filter/state.js